angular.module('bribac.entities.insuranceProviderFactory', [])
    .value('insuranceProviderFactory', function insuranceProviderFactory(data) {
        return angular.merge({
            username: null,
            lastName: null,
            firstName: null,
            middleName: null,
            npi: null,
            mainGroupsIds: []
        }, data)
    })
